import {
  isOnPageOutsideSections,
  isPlanSectionsDocked,
  PLAN_SECTION_DIALOG_ATTRIBUTE,
  requestPlanSectionDialog,
  scrollElementIntoPage,
} from 'partner360/lib/planSectionDialog'

export const scrollToElement = (elementId: string) => {
  const element = document.getElementById(elementId)

  if (isPlanSectionsDocked() && !isOnPageOutsideSections(element)) {
    if (element?.closest(`[${PLAN_SECTION_DIALOG_ATTRIBUTE}]`)) {
      scrollElementIntoPage(element)
    } else {
      requestPlanSectionDialog(elementId)
    }

    return
  }

  const rect = element?.getClientRects()[0]

  if (rect) {
    window.scrollTo({
      top: window.scrollY + rect.top - 150,
    })
  }
}
